const styles = (theme) => ({
  containerPaper: {
    backgroundColor: theme.palette.background.paper,
    padding: "20px",
    borderRadius: "16px",
    display: "flex",
    flexDirection: "column",
  },
  containerActions: {
    width: "100%",
    margin: "20px 0",
    display: "flex",
    flexWrap: "wrap",
    gap: 2,
  },
  boxDatagrid: {
    height: "80vh",
  },
  boxContainer: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
  },
  chipVigencia: {
    backgroundColor: theme.palette.chip.background.success,
    color: theme.palette.chip.colorText.success,
    border: "0.6px solid ",
    borderColor: theme.palette.chip.colorText.success,
    borderRadius: "10px",
    height: "20px",
    width: "100%",
  },
  iconArraw: {
    p: 0.5,
    width: 24,
    height: 24,
  },
  chipProxima: {
    backgroundColor: theme.palette.chip.background.high,
    color: theme.palette.chip.colorText.high,
    border: "0.6px solid ",
    borderColor: theme.palette.colors.orange.medium,
    borderRadius: "10px",
    height: "20px",
    width: "100%",
  },
  chipExpirado: {
    backgroundColor: theme.palette.chip.background.critical,
    color: theme.palette.chip.colorText.critical,
    border: "0.1px solid ",
    borderColor:
      theme.palette.mode === "dark"
        ? theme.palette.colors.red.darker
        : theme.palette.colors.red.light,
    borderRadius: "10px",
    height: "20px",
    width: "100%",
  },
  chipDefault: {
    border: "0.1px solid ",

    borderRadius: "10px",
    height: "20px",
    width: "100%",
  },
  textfield: {
    width: "100%",
    maxWidth: 500,
    fontSize: "0.75rem", // diminui fonte geral
  },
  autocomplete: {
    width: "100%",
    maxWidth: 500,
    fontSize: "0.75rem", // diminui fonte geral
  },
});

export default styles;
